import { FC, SVGAttributes } from "react";

const PeopleIcon: FC<SVGAttributes<SVGSVGElement>> = ({
  stroke = "#000",
  width = 24,
  height = 24,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <g id="people" stroke={stroke} strokeLinecap="round" strokeLinejoin="round">
      <path
        id="Vector"
        d="M6.54543 19.3637H3.81817V16.091H2V12.0002C2 11.0962 2.81363 10.3639 3.81817 10.3639H4.72725M17.4546 19.3637H20.1818V16.091H22V12.0002C22 11.0962 21.1864 10.3639 20.1818 10.3639H19.2728M4.72775 7.90945C3.72322 7.90945 2.90959 7.17719 2.90959 6.27313C2.90959 5.36905 3.72322 4.6368 4.72775 4.6368C5.7323 4.6368 6.54593 5.36905 6.54593 6.27313C6.54593 7.17719 5.7323 7.90945 4.72775 7.90945ZM19.2728 7.90945C20.2773 7.90945 21.0909 7.17719 21.0909 6.27313C21.0909 5.36905 20.2773 4.6368 19.2728 4.6368C18.2682 4.6368 17.4546 5.36905 17.4546 6.27313C17.4546 7.17719 18.2682 7.90945 19.2728 7.90945ZM11.9998 7.90898C10.4934 7.90898 9.27247 6.81018 9.27247 5.45449C9.27247 4.09879 10.4934 3 11.9998 3C13.5061 3 14.727 4.09879 14.727 5.45449C14.727 6.81018 13.5061 7.90898 11.9998 7.90898ZM14.7274 21H9.2729V16.091H7.45472V12.0002C7.45472 11.0962 8.26835 10.3639 9.2729 10.3639H14.7274C15.7319 10.3639 16.5456 11.0962 16.5456 12.0002V16.9092H14.7274V21Z"
        stroke="black"
        strokeWidth="1.8"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  </svg>
);

export { PeopleIcon };
